import React, { Suspense, useEffect, useState } from "react";
import { batch, connect } from "react-redux";
import Format from "string-format";
import axios from "axios";
import PropTypes from "prop-types";
import TldrSavedCopies from "../../TldrAi/TldrSavedCopies";
import { updateDocument } from "../../_actions/aiDocumentActions";
import {
  DOCUMENT_DETAILS,
  NEW_DOCUMENTS_ENDPOINT,
} from "../../_actions/endpoints";
import { handleHTTPError } from "../../_actions/errorHandlerActions";
import {
  ADVANCED_AI_DOCUMENTS,
  ADVANCED_AI_EDITOR_PANEL,
  ADVANCED_AI_RESULTS,
} from "../details/constants";
import { openAdvancedSettings } from "../../_actions/sidebarSliderActions";
import AiHistory from "../../TldrAi/AiHistory";
import { ShowCenterSpinner } from "./statelessView";
const AiInputForm = React.lazy(() =>
  import("../../TldrAi/AiInputForms/AiInputForm")
);
const AiResults = React.lazy(() => import("../../TldrAi/AiResults"));

function TldrStudioAiPanel(props) {
  const { onAddText } = props;
  const { selectedTab, aiPromptId } = props.rightsidebar;
  const { data } = props.document;

  const [loaded, setLoaded] = useState(false);
  let signalToken = axios.CancelToken.source();

  function fetchDocumentDetails(promptId) {
    setLoaded(false);
    axios
      .get(Format(DOCUMENT_DETAILS, promptId), {
        cancelToken: signalToken.token,
      })
      .then((res) => {
        props.updateDocument(res.data);
        setLoaded(true);
      })
      .catch((error) => {
        setLoaded(true);
        props.handleHTTPError(error, props);
      });
  }

  useEffect(() => {
    setLoaded(false);
    if (selectedTab === ADVANCED_AI_RESULTS) {
      fetchDocumentDetails(aiPromptId);
    }
  }, [selectedTab]);

  function handleDocumentAddNow(result) {
    if (onAddText) {
      onAddText(result);
    }
  }

  function createNewDocument() {
    axios
      .post(NEW_DOCUMENTS_ENDPOINT, {}, { cancelToken: signalToken.token })
      .then((res) => {
        batch(() => {
          props.updateDocument(res.data);

          props.openAdvancedSettings(
            ADVANCED_AI_EDITOR_PANEL,
            ADVANCED_AI_RESULTS,
            res.data.id
          );
        });
      })
      .catch((error) => {
        props.handleHTTPError(error, props);
      });
  }

  return (
    <>
      {selectedTab === ADVANCED_AI_DOCUMENTS ? (
        <TldrSavedCopies
          renderlocation={props.renderlocation}
          onCreateNewDocument={createNewDocument}
          showRecentFolders={false}
          showExtraOptions={false}
        ></TldrSavedCopies>
      ) : selectedTab === ADVANCED_AI_RESULTS ? (
        <>
          <Suspense fallback={<div></div>}>
            {data.prompt ? (
              <>
                <AiInputForm resultsView={true}></AiInputForm>
                <AiHistory
                 type="longform"
                 handleDocumentAddNow={(result) =>
                   handleDocumentAddNow(result)
                 }
                 fitted={true}
                />
              </>
            ):
            <ShowCenterSpinner loaded={data.prompt}/>
            }
          </Suspense>
        </>
      ) : (
        <></>
      )}
    </>
  );
}

TldrStudioAiPanel.propTypes = {
  rightsidebar: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  rightsidebar: state.rightsidebar,
  document: state.document,
});

const mapDispatchToProps = (dispatch) => ({
  handleHTTPError: (error, props) => dispatch(handleHTTPError(error, props)),
  updateDocument: (payload) => dispatch(updateDocument(payload)),
  openAdvancedSettings: (panel, selectedTab, documentId) =>
    dispatch(openAdvancedSettings(panel, selectedTab, documentId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(TldrStudioAiPanel);
